<div class="card-header">
  <app-breadcrumb currentPage="kies een bank"></app-breadcrumb>
</div>

<div class="card-body">

  <h2>Van welke bank wilt u banktransacties importeren?</h2>

  <div class="bank-picker">

    <!-- page 1 -->
    <div class="bank"
         (click)="route('rabobank')"
         style="background-image: url('assets/bank-logos/rabobank.svg');
                background-size: 90px;">
    </div>
    <div class="bank"
         (click)="route('ing')"
         style="background-image: url('assets/bank-logos/ing.svg');
                background-size: 200px;"></div>
    <div class="bank"
         (click)="route('abn-amro')"
         style="background-image: url('assets/bank-logos/abn-amro.svg');
                background-size: 190px;"></div>
    <div class="bank"
         (click)="route('asn-bank')"
         style="background-image: url('assets/bank-logos/asn-bank.svg');
                background-size: 180px;"></div>

    <div class="bank"
         (click)="route('sns')"
         style="background-image: url('assets/bank-logos/sns.svg');
                background-size: 250px">

    </div>
    <div class="bank"
           (click)="route('bunq')"
           style="background-image: url('assets/bank-logos/bunq.svg');
                  background-size: 100px;">
      </div>
      <div class="bank"
           (click)="route('regiobank')"
           style="background-image: url('assets/bank-logos/regiobank.svg');
                  background-size: 150px;">
      </div>
      <div class="bank"
           (click)="route('knab')"
           style="background-image: url('assets/bank-logos/knab.svg');
                  background-size: 160px;">
      </div>
      <div class="bank"
           (click)="route('van-lanschot')"
           style="background-image: url('assets/bank-logos/van-lanschot.svg');
                  background-size: 210px;">
      </div>
      <div class="bank"
           (click)="route('triodos')"
           style="background-image: url('assets/bank-logos/triodos.svg');
                  background-size: 250px;">
      </div>
    <div class="no-hover">
      <button class="btn plus inverted block auto center-y" (click)="route('andere-bank')">andere bank</button>
    </div>

  </div>
  <div class="clearFix"></div>

</div>
